export function imprimirEtiquetasDecAGR() {
  const urlsAgregadores = {
    url1: 'https://segurosdecoche.mapfre.es/agr/',
    url2: 'https://segurosdemoto.mapfre.es/agr/',
    url3: 'https://segurosdehogar.mapfre.es/agr/',
    url4: 'https://segurosdesalud.mapfre.es/agr/',
    url5: 'https://seguroparamascotas.mapfre.es/agr/',
    url6: 'https://segurosdeviajes.mapfre.es/agr/',
    url7: 'https://segurodecesos.mapfre.es/agr/'
  }
  const urlActual = window.location.origin + window.location.pathname

  for (const url in urlsAgregadores) {
    if (urlActual === urlsAgregadores[url]) {
      const posiblesIDs = ['id', 'id1', 'id2', 'id3', 'id4']
      const urlParams = new URLSearchParams(window.location.search)
      let cod_presupuesto = null
      const formularios = document.querySelectorAll('.wg-form')
      const name = 'cod_presupuesto'

      for (const possibleID of posiblesIDs) {
        const paramValue = urlParams.get(possibleID)
        if (paramValue !== null) {
          cod_presupuesto = paramValue
          break
        }
      }
      if (cod_presupuesto !== null) {
        console.log('cod_presupuesto recogido: ' + cod_presupuesto)
        if (window.userLabels.EDeclaratives) window.userLabels.EDeclaratives[name] = cod_presupuesto
        const hiddenDec = `<input type="hidden" name="cod_presupuesto" id="cod_presupuesto" value="${cod_presupuesto}" >`
        formularios.forEach((form) => {
          console.log('seteo: ' + hiddenDec)
          form.innerHTML += hiddenDec
        })
      } else {
        console.log('cod_presupuesto == null')
      }
    }
  }
}
